/* eslint-disable */
const emailRegex = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@([a-z0-9][a-z0-9-]*)*[a-z0-9]\.[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

// SLD = second layer domain
const emailWithSld = function(value, attrValue, vnode) {
  return emailRegex.test(value);
};

export const customValidators = {
  emailWithSld,
};
